// extracted by mini-css-extract-plugin
export default {"BorderTop":"Footer_BorderTop__oMp2l","Logo":"Footer_Logo__8K5R3","NYSE":"Footer_NYSE__fPASi","LegalLink":"Footer_LegalLink__+qmNa"};